// import { Capacitor } from '@capacitor/core'
import { Window, Entry, FileEntry } from '../@types/cordova-plugin-file'
import { FilePicker, PickMediaOptions, PickFilesResult } from '@capawesome/capacitor-file-picker'
// import imageThumbnail from 'image-thumbnail'

/* eslint-disable @typescript-eslint/no-explicit-any */

export let inFilePicker: boolean = false

export async function presentMediaPicker (options?: { selectMode?: number, thumbnailResolution?: number }) {
  const args = {
    'selectMode': 101, //101=picker image and video , 100=image , 102=video
    'maxSelectCount': 1, //default 40 (Optional)
    'maxSelectSize': 100 * 1024 * 1024, // (Optional)
    'thumbnailQuality': 80,
    'thumbnailResolution': 512,
  }
  if (options?.selectMode) {
    args.selectMode = options.selectMode
  }
  if (options?.thumbnailResolution) {
    args.thumbnailResolution = options.thumbnailResolution
  }

  const filePickerOptions: PickMediaOptions = {
    readData: true, // read file data
    skipTranscoding: false, // transcoding HEIC to JPEG
    limit: args.maxSelectCount,
  }
  const pickMedia = async (): Promise<PickFilesResult | undefined> => {
    let result: PickFilesResult | undefined
    inFilePicker = true
    switch (args.selectMode) {
      case 100:
        // Handle image selection
        result = await FilePicker.pickImages(filePickerOptions)
        break
      case 102:
        // Handle video selection
        result = await FilePicker.pickVideos(filePickerOptions)
        break
      case 101:
        // Handle image and video selection
        result = await FilePicker.pickMedia(filePickerOptions)
        break
    }
    inFilePicker = false
    return result
  }
  const result = await pickMedia()
  if (result?.files?.length) {
    return result.files.map((file) => {
      // Convert the file to a File object
      const fileObj = base64ToFile(file.data!, file.name, file.mimeType)
      return { file: fileObj }
    })
  } else {
    return []
  }

  // return new Promise<{file: File}[]>((resolve, reject) => {
  //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   MediaPicker.getMedias(args, async (medias: any[]) => {
  //     if (!medias.length) {
  //       console.error('MediaPicker: ' + 'selection empty')
  //       resolve([])
  //       return
  //     }
  //     const result: { file: File}[] = []
  //     for (const i of medias) {
  //       let url: string = i.uri
  //       if (Capacitor.getPlatform() == 'android') {
  //         url = 'file://' + i.path
  //       }
  //       const thumbnail = await getThumbnail(i)
  //       const file = await getFile(url)
  //       // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //       const f_: any = file; f_.thumbnail = thumbnail
  //       result.push({ file })
  //     }
  //     resolve(result)
  //   },
  //   reject)
  // })
}

function base64ToFile (base64String: string, filename: string, mimeType: string): File {
  // Extract the actual base64 data if it includes a data URL prefix
  let base64Data = base64String
  if (base64String.includes(',')) {
    const parts = base64String.split(',')
    base64Data = parts[1] || parts[0]
  }

  // Decode Base64 to binary string
  const binaryString = atob(base64Data)

  // Convert binary string to a Uint8Array
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  // Create a Blob from the Uint8Array
  const blob = new Blob([bytes], { type: mimeType })

  // Create a File object (optional, for scenarios like uploading)
  // NOTE: cordova 환경에서 File 생성자가 제대로 동작하지 않는 문제 대응
  // const file = new File([blob], filename, { type: mimeType })
  const file = blob as File
  ;(file as any).name = filename
  ;(file as any).lastModified = Date.now()

  return file
}

type ProgressCallback = (event: { loaded: number }) => void
export async function readFileEntry (entry: FileEntry, progress?: ProgressCallback) {
  return new Promise<ArrayBuffer>((resolve, reject) => {
    entry.file((file) => {
      const reader = new FileReader()
      reader.onprogress = (event: { loaded: number }) => {
        if (progress) {
          progress(event)
        }
      }
      reader.onloadend = async () => {
        const data = reader.result as unknown as ArrayBuffer
        // const f_ = file as any
        // f_.data = reader.result
        resolve(data)
      }
      reader.onerror = reject
      reader.readAsArrayBuffer(file)
    })
  })
}

// export async function getThumbnail (media: unknown): Promise<string> {
//   try {
//     const thumbnail = await imageThumbnail(media as string, {
//       responseType: 'base64',
//     })
//     return 'data:image/jpeg;base64,' + thumbnail
//   } catch (e) {
//     console.error('getThumbnail: error = ', e)
//     return ''
//   }
//   // return new Promise((resolve, reject) => {
//   //   MediaPicker.extractThumbnail(media, (data: { thumbnailBase64: string }) => {
//   //     resolve('data:image/jpeg;base64,' + data.thumbnailBase64)
//   //   }, reject)
//   // })
// }

export async function getFile (url: string): Promise<File | undefined> {
  const w = window as unknown as Window
  return new Promise<File>((resolve, reject) => {
    w.resolveLocalFileSystemURL(url, (entry: Entry) => {
      const fileEntry = entry as FileEntry
      fileEntryToFile(fileEntry).then((file: File) => {
        resolve(file)
      }).catch((reason: unknown) => {
        reject
      })
      // const file = fileEntryToFile(fileEntry)
      // resolve(file)
    },
    reject)
  })
}

async function fileEntryToFile (entry: FileEntry): Promise<File> {
  return new Promise((resolve, reject) => {
    entry.file(async (file: File) => {
      // const buffer = await fileToArrayBuffer(file)
      // file = new File([buffer], file.name, { type: file.type })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const f_ = file as any
      // if (Capacitor.getPlatform() == 'android') {
      //   f_.fileURL = entry.toURL()
      // } else if (Capacitor.getPlatform() == 'ios') {
      f_.entry = entry
      // }
      resolve(file)
    },
    reject)
  })
}

// async function fileToArrayBuffer (file: File) {
//   return new Promise<ArrayBuffer>((resolve, reject) => {
//     const reader = new FileReader()
//     reader.onload = () => {
//       if (reader.result) {
//         resolve(reader.result as ArrayBuffer)
//       } else {
//         reject(new Error('FileReader result is null'))
//       }
//     }
//     reader.onerror = () => {
//       reject(reader.error)
//     }
//     reader.readAsArrayBuffer(file)
//   })
// }

export async function fileToDataUrl (file: File) {
  //   name: file.name,
  //   size: file.size,
  //   type: file.type,
  //   constructorName: file.constructor.name,
  // })

  return new Promise<string>((resolve, reject) => {
    try {
      const reader = new FileReader()

      reader.onload = () => {
        if (reader.result) {
          const result = reader.result as string
          // alert('[fileToDataUrl] 성공!\n길이: ' + result.length + '\n' + result.slice(0, 50))
          resolve(result)
        } else {
          console.error('[fileToDataUrl] reader.result is null')
          // alert('[fileToDataUrl] 오류!\nreader.result is null')
          reject(new Error('FileReader result is null'))
        }
      }

      reader.onerror = () => {
        const error = reader.error
        console.error('[fileToDataUrl] FileReader 오류:', error)
        // alert('[fileToDataUrl] FileReader 오류!\n' + (error ? error.toString() : 'Unknown error'))
        reject(error)
      }

      // alert('[fileToDataUrl] readAsDataURL 호출 중...')
      reader.readAsDataURL(file)
    } catch (error) {
      // const errMsg = error instanceof Error ? error.message : String(error)
      console.error('[fileToDataUrl] 예외 발생:', error)
      // alert('[fileToDataUrl] 예외 발생!\n' + errMsg)
      reject(error)
    }
  })
}

